module.exports = __webpack_public_path__ + "img/Alejandro.5982b6d9.png";